import React from 'react';
import './TrustedBy.css';
import { motion } from 'framer-motion';

/**
 * Companies the work has shipped for (employers and organisations only, not client projects).
 * To show a real logo instead of the wordmark tile, import the file and add
 * `logo: thatImport` to the entry; everything else stays the same.
 */
const CLIENTS = [
  { name: 'REMAP.ai',   tag: 'AI Consultancy · Australia', initials: 'R', url: 'https://remap.ai' },
  { name: 'Private AI', tag: 'Enterprise AI Platform',     initials: 'P', url: 'https://useprivate.ai' },
];

const Tile = ({ client }) => (
  client.logo ? (
    <img className="trusted__logo" src={client.logo} alt={client.name} loading="lazy" decoding="async" />
  ) : (
    <>
      <span className="trusted__mark" aria-hidden="true">{client.initials}</span>
      <span className="trusted__text">
        <span className="trusted__name">{client.name}</span>
        <span className="trusted__tag">{client.tag}</span>
      </span>
    </>
  )
);

const TrustedBy = () => (
  <section id="trusted-by" className="trusted" aria-label="Companies I have worked with">
    <motion.div
      className="container trusted__container"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <p className="trusted__eyebrow">Trusted by teams at</p>
      <ul className="trusted__list">
        {CLIENTS.map((client) => (
          <li key={client.name}>
            {client.url ? (
              <a
                className="trusted__item trusted__item--link"
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${client.name}, ${client.tag} (opens in a new tab)`}
              >
                <Tile client={client} />
              </a>
            ) : (
              <div className="trusted__item">
                <Tile client={client} />
              </div>
            )}
          </li>
        ))}
      </ul>
    </motion.div>
  </section>
);

export default TrustedBy;
